import Widget             from "lib/widget";

class ChecklistCompleteWidget extends Widget {
  bind() {
    checkCompletion.call(this);
  }
}

let checkCompletion = function() {
  let url = window.location.href;
  let id = url.substring(url.lastIndexOf('/') + 1).split(/\#|\?/)[0];
  let requestUrl = ''

  if (url.match(/external\/project/)) {
    requestUrl += `/external/project/${id}/checklist_status`
  } else {
    // no need to handle /external/account requests as they have the PK in the url anyway
    requestUrl += `/projects/${id}/checklist_status`
  }

  $.ajax({
    url: requestUrl,
    type: "GET",
    dataType: 'json',
    success: (data) => {
      for (let key in data){
        let tab = $('#approve-' + key.toLowerCase())
        if (tab.length === 0) { continue; }
        if (data[key] === 0) {
          tab[0].disabled = false;
        } else {
          tab[0].disabled = true;
        }
      }
    }
  });
}

export default ChecklistCompleteWidget
